<template>
  <section>
    <BanksCountry/>
    <Loader class="mx-auto" v-if="loading" />
    <div v-else>
      <form class="mb-3" v-on:submit.prevent>
        <input type="search" class="form-control d-inline-block mr-3 align-top" :placeholder="$t('banksPage.searchText')" v-model="searchKey">
        <BanksPsuType class="d-inline-block" />
      </form>
      <enablebanking-aspsp-list
        :origin="BROKER_ORIGIN"
        :sandbox="SANDBOX"
        :country="selectedCountry"
        :psu-type="selectedPsuType"
        :search-term="searchKey"
        service="AIS"
        logo-transform="-/resize/250x/"
        v-on:selected="handleAspspSelected"
      ></enablebanking-aspsp-list>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import BanksCountry from './BanksCountry'
import BanksPsuType from './BanksPsuType'
import {BROKER_ORIGIN, SANDBOX} from '../../constants'

export default {
  name: 'home',
  data() {
    return {
      searchKey: new URLSearchParams(window.location.search).get('search') || '',
      BROKER_ORIGIN: BROKER_ORIGIN,
      SANDBOX: SANDBOX
    }
  },
  computed: {
    filteredBanks() {
      return this.banks.length && this.banks.filter(bank => {
        return bank.name.toLowerCase().includes(this.searchKey.toLowerCase()) &&
          bank.psu_types.includes(this.selectedPsuType)
      })
    },
    ...mapState('base', ['banks', 'loading', 'errorsAlertList']),
    ...mapGetters('personal', ['selectedCountry', 'selectedPsuType'])
  },
  components: {
    BanksCountry,
    BanksPsuType
  },
  methods: {
    ...mapActions('auth', ['startSession']),
    ...mapActions('personal', ['wipeAllData']),
    handleAspspSelected(event) {
      this.getBankAuth(event.detail.name, event.detail.name)
    },
    async getBankAuth(id, name) {
      this.wipeAllData()
      const payload = {
        bankId: id,
        brand: name
      }
      const sessionStarted = await this.startSession(payload)

      if (sessionStarted) {
        console.log(sessionStarted)
        this.$emit('sessionStarted')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/variables";
input[type=search]{
  max-width: 363px;
}

::v-deep enablebanking-aspsp-list .card-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 0.65rem;
}

::v-deep enablebanking-aspsp-list .beta-flag{
  color: #6c757d!important;
}

::v-deep enablebanking-aspsp-list .radio-chips{      // copied from _elements.scss    
  margin: 0;
  &__content{
    display: block;
    padding: 0.53rem 1rem;
    border: 1px solid $gray-200;
    border-radius: $border-radius;
    margin-bottom: 0;
    cursor: pointer;
    position: relative;
    box-shadow: none;
    &:hover{
      background-color: $gray-100;
      background-color: var(--element-bg-dark);
    }
    &:active{
      background-color: $gray-100;
      background-color: var(--element-bg-dark);
    }
  }
  &--active{
    .radio-chips__content{
      transition: box-shadow 0.2s;
      box-shadow: inset 0 0 0 2px $gray-900;
      box-shadow: inset 0 0 0 2px var(--element-border-dark);
    }
  }
  input{
    display: none;
    &:checked{
      &+.radio-chips__content{
        transition: box-shadow 0.2s;
        background-color: var(--element-bg-dark);
        box-shadow: inset 0 0 0 2px $gray-900;
        box-shadow: inset 0 0 0 2px var(--element-border-dark);
      }
    }
  }
  &__pic{
    height: 40px;
    max-width: 120px;
    display: block;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    img{
      max-height: 50%;
      max-width: 100%;
    }
  }
  &__title{
    margin-bottom: 0.3rem;
    display: block;
    white-space: nowrap;
    overflow: hidden;
  }
  &--sm{
    .radio-chips__content{
      padding: 0.25rem 1rem;
      border-radius: $border-radius-lg * 2;
      font-size: $font-size-sm;
    }
  }
}

</style>
